export default __webpack_public_path__ + "static/media/desktop_banner_cancellations.ea16df2b.jpg";